import { _ as r } from "../internals/export.js";
import { g as n } from "../internals/global.js";
import { f as t } from "../internals/function-apply.js";
import { w as o } from "../internals/wrap-error-constructor-with-cause.js";
var u = "WebAssembly",
  i = n[u],
  e = 7 !== Error("e", {
    cause: 7
  }).cause,
  c = function c(n, t) {
    var u = {};
    u[n] = o(n, t, e), r({
      global: !0,
      constructor: !0,
      arity: 1,
      forced: e
    }, u);
  },
  f = function f(n, t) {
    if (i && i[n]) {
      var c = {};
      c[n] = o(u + "." + n, t, e), r({
        target: u,
        stat: !0,
        constructor: !0,
        arity: 1,
        forced: e
      }, c);
    }
  };
c("Error", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("EvalError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("RangeError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("ReferenceError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("SyntaxError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("TypeError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), c("URIError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), f("CompileError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), f("LinkError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
}), f("RuntimeError", function (r) {
  return function (n) {
    return t(r, this, arguments);
  };
});